import { css } from 'styled-components'

export const BUTTON_HEIGHT = '40px'
export const SHADOW_LV1 = '0 2px 7px 0 rgba(0, 0, 0, 0.1)'
export const SHADOW_LV2 = '0 2px 15px 0 rgba(0, 0, 0, 0.25)'

export const BUTTON_SHADOW = '0 15px 20px 0 rgba(0, 0, 0, 0.1)'
export const HOVER_SHADOW = '0 2px 15px 0 rgba(0, 0, 0, 0.25)'

export const FLEX_CENTER = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

export { COLOR } from './color'

export * from './typography'
